import { render, staticRenderFns } from "./PaymentDetailSCT.vue?vue&type=template&id=0fee0042&"
import script from "./PaymentDetailSCT.vue?vue&type=script&lang=js&"
export * from "./PaymentDetailSCT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports